import { render, staticRenderFns } from "./MedicineList.vue?vue&type=template&id=e5dca226&scoped=true"
import script from "./MedicineList.vue?vue&type=script&lang=js"
export * from "./MedicineList.vue?vue&type=script&lang=js"
import style0 from "./MedicineList.vue?vue&type=style&index=0&id=e5dca226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5dca226",
  null
  
)

export default component.exports